import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          <h1 className="mb-3">Política de Privacidade — Atmo Workplace</h1>
          <p className="text-muted mb-4">Última atualização: 28 de maio de 2025</p>

          <section className="mb-4">
            <p>
              Na <strong>Atmo Digital</strong>, respeitamos a sua privacidade e estamos comprometidos com a proteção dos seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos suas informações ao utilizar a plataforma <strong>Atmo Workplace</strong>.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">1. Informações que coletamos</h2>
            <ul>
              <li>Nome completo, e-mail, cargo e informações de perfil;</li>
              <li>Dados de login e autenticação;</li>
              <li>Publicações, comentários, mensagens e interações;</li>
              <li>Informações de uso (logs, IP, dispositivo, navegador, localização aproximada);</li>
              <li>Conteúdo multimídia enviado (imagens, vídeos, arquivos).</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5">2. Como usamos seus dados</h2>
            <ul>
              <li>Permitir acesso e funcionamento do Atmo Workplace;</li>
              <li>Personalizar sua experiência na plataforma;</li>
              <li>Melhorar nossos serviços com base em análises de uso;</li>
              <li>Comunicar informações relevantes, como atualizações, notificações e suporte;</li>
              <li>Cumprir obrigações legais e regulatórias.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5">3. Compartilhamento de dados</h2>
            <p>Não vendemos nem compartilhamos seus dados com terceiros, exceto quando:</p>
            <ul>
              <li>Com parceiros contratados para operar recursos essenciais do sistema;</li>
              <li>Quando exigido por lei ou ordem judicial;</li>
              <li>Com consentimento expresso do usuário.</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h5">4. Armazenamento e segurança</h2>
            <p>
              Seus dados são armazenados em servidores seguros e utilizamos criptografia, autenticação e práticas de segurança para protegê-los contra acesso não autorizado, alteração ou destruição.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">5. Seus direitos</h2>
            <p>Você tem o direito de:</p>
            <ul>
              <li>Acessar seus dados pessoais;</li>
              <li>Corrigir informações incorretas;</li>
              <li>Solicitar a exclusão de dados, quando permitido por lei;</li>
              <li>Revogar consentimentos;</li>
              <li>Solicitar portabilidade dos dados.</li>
            </ul>
            <p>
              Para exercer seus direitos, entre em contato pelo e-mail: <strong>privacidade@atmodigital.com.br</strong>
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">6. Retenção de dados</h2>
            <p>
              Mantemos seus dados enquanto sua conta estiver ativa ou conforme necessário para cumprir obrigações legais, resolver disputas e fazer valer nossos contratos.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">7. Cookies e tecnologias similares</h2>
            <p>
              Utilizamos cookies para melhorar a navegação, autenticar sessões e coletar estatísticas de uso. Você pode configurar seu navegador para recusar cookies, mas isso pode limitar funcionalidades do sistema.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">8. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta política periodicamente. Notificaremos os usuários sobre mudanças relevantes por meio da própria plataforma ou por e-mail.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h5">9. Contato</h2>
            <p>
              Se você tiver dúvidas sobre esta Política de Privacidade ou sobre seus dados pessoais, entre em contato conosco:
            </p>
            <p className="mt-2">
              E-mail: <strong>contato@atmodigital.com.br</strong><br/>
            </p>
            <p className="mt-2">
             Tel: <strong>+55 (11) 2990-1200</strong>
            </p>
            <p className="mt-2">
              Endereço: <strong>Av. Engenheiro Caetano Álvares, 7191 Mandaqui, São Paulo, SP</strong>
            </p>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;